export const alphaLocaleCompare = (a, b) => a.toLowerCase().localeCompare(b.toLowerCase());
